<template>
    <!-- 30医学专栏-->
    <div class="medicine-list-section">
        <div class="medicine-list-section-box" @click="go(dataItem)">
            <div class="medicine-list-section-left">
                <van-image class="medicine-list-section-left-img" fit="cover" :src="dataItem.cover_img" />
            </div>
            <div class="medicine-list-section-right">
                <div class="medicine-list-section-right-title">{{ dataItem.title }}</div>
                <div class="medicine-list-section-right-detail" v-if="dataItem.type == 2">
                    共{{ dataItem.total_count }}篇
                    <span
                        class="medicine-list-section-right-detail-join"
                        v-if="dataItem.is_subscribe === 1"
                        @click.stop="attention(dataItem, dataItem)"
                    >
                        <img src="static/v4/icon_follow.svg" style="margin-right: 2px" />
                        关注
                    </span>
                    <span v-else class="medicine-list-section-right-detail-join1" @click.stop="attention(dataItem, dataItem)">已关注</span>
                </div>
                <div class="medicine-list-section-right-detail" v-else>
                    <span>{{ dataItem.created_at }}</span>
                    <span>{{ dataItem.view_count }}人阅读</span>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
    name: 'medicine',
    props: {
        dataItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {}
    },
    methods: {
        // 关注/未关注
        attention(content, item) {
            // is_subscribe 0 已关注  1 未关注
            if (content.is_subscribe == 0) {
                // 取消关注
                this.$dialog
                    .confirm({
                        title: '提醒',
                        message: '确定取消关注吗？',
                        confirmButtonText: '确定',
                        className: 'dly-dialog'
                    })
                    .then(() => {
                        Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
                            if (res.code == 0) {
                                this.$toast.success('取消关注成功')
                                // this.changeCategory()
                            }
                        })
                    })
                    .catch(() => {
                        console.log(1)
                    })
            } else {
                // 关注
                Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
                    if (res.code == 0) {
                        this.$toast.success('关注成功')
                        // this.$parent.$parent.changeCategory()
                    }
                })
            }
        },
        go(item) {
            this.$router.push({ name: 'topic-detail', params: { id: item.origin_id } })
        }
    }
}
</script>

<style scoped lang="scss">
.medicine-list-section {
    &-box {
        display: flex;
        flex-direction: row;
        width: 355px;
        position: relative;
        margin: 0 auto;
        padding-top: 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid #f2f2f2;
        background: #fff;
        border-radius: 8px;
        margin-top: 10px;
    }
    .last {
        border-bottom-width: 0px;
    }
    &-left {
        width: 140px;
        position: relative;
        border-radius: 6px;
        padding-left: 12px;
        &-img {
            width: 130px;
            height: 72px;
            background: #eff3fa;
            border-radius: 6px;
            img {
                border-radius: 6px;
            }
            /deep/ .van-image__img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
        }
        &-time {
            width: 100%;
            bottom: 0px;
            position: absolute;
            color: #fff;

            font-family: Avenir-Heavy;
            font-size: 11px;
            letter-spacing: 0;
            text-align: right;

            background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
            border-radius: 0 0 6px 6px;

            span {
                display: inline-block;
                margin-bottom: 4px;
                margin-right: 8px;
            }
        }
    }

    &-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-right: 12px;
        &-title {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #222222;
            text-align: justify;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
            .light {
                color: #d81d33;
            }
        }
        &-author {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #404040;
            letter-spacing: 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
        }
        &-detail {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9d9d9d;
            &-join {
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: PingFangSC-Medium;
                width: 61px;
                height: 30px;
                //line-height: 30px;
                //text-align: center;
                background: #feeed5;
                border-radius: 17px;
                font-size: 13px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #b6855e;
            }
            &-join1 {
                width: 61px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                background: rgba(221, 221, 221, 0.3);
                border-radius: 17px;
                font-size: 13px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #907970;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/newItemconent/modules/medicine.vue